import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { connect } from 'react-redux';
import View from '../../../desktop/product/View';
import Description from './Description';
import ImgView from '../../../desktop/product/ImgView';
import * as actions from '../../../../actions/productData';
import Modal from '../../Modal';
import ErrorMessage from '../../ErrorMessage';
import { Feature, Variant } from '../../../../refresh/organism/ABFeature';

class ProductQuickview extends React.Component {
  render() {
    const newDesignLuxe = this.props.newDesignLuxe;
    const productData = this.props.product;
    let selectedImageId = this.props.selectedImageId;
    let onSelect = this.props.onSelect;
    let onSelectColor = this.props.onSelectColor;
    let viewRender = 'quickview';
    let { httpError = {} } = this.props;
    let { error: { message = '', originator = '', errorType = '' } = {} } = httpError;
    return (
      <div>
        <Modal name="quickview-modal" className="quickview-modal" id="quickview-modal">
          {this.props.error && this.props.error.quickview_size_error && (
            <div className="err-msg-blk">
              <ErrorMessage message={this.props.error.quickview_size_error} />
            </div>
          )}
          {Object.keys(httpError).length != 0 && errorType && (
            <div className="err-msg-blk">
              <ErrorMessage message={message} />
            </div>
          )}
          <Row className="product-quickview">
            <Col xs={2}>
              <ImgView
                imgdata={productData}
                selectedImageId={selectedImageId}
                onSelect={onSelect}
                viewRender={viewRender}
              />
            </Col>
            <Col xs={6}>
              <Feature featureName="enable_urgency_driver_pdp">
                <Variant id="0">
                  <View
                    imgdata={productData}
                    selectedImageId={selectedImageId}
                    onSelect={onSelect}
                    viewRender={viewRender}
                    newDesignLuxe={newDesignLuxe}
                    isNewProductTag={false}
                  />
                </Variant>
                <Variant id="1">
                  <View
                    imgdata={productData}
                    selectedImageId={selectedImageId}
                    onSelect={onSelect}
                    viewRender={viewRender}
                    newDesignLuxe={newDesignLuxe}
                    isNewProductTag
                  />
                </Variant>
              </Feature>
            </Col>
            <Col xs={4}>
              <Description
                productData={productData}
                onSelectColor={onSelectColor}
                viewRender={viewRender}
              />
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { modals = {}, httpError = {} } = state;
  const modal = modals['quickview-modal'] || {};
  const product = modal.state ? modal.state.product : {};
  return {
    product,
    httpError,
    selectedImageId: state.product.selectedImageId,
    error: state.error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSelect: productId => dispatch(actions.onSelectById(productId)),
    onSelectColor: productId => dispatch(actions.onSelectColor(productId))
  };
};

export default ProductQuickview = connect(mapStateToProps, mapDispatchToProps)(ProductQuickview);
